import { isInrCurrency } from '@/utils/currency';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { payMethodMap } from '@/views/checkout/payment/helper/constant';

/**
 * INR F2P: don't use default payment method
 *
 * @returns {boolean}
 */
export const canUseDefaultPaymentMethod = () => {
  if(!isInrCurrency()) {
    return true;
  }
  let useDefaultPaymentMethod = true;
  if ([flowTypes.basic2pro, flowTypes.trial2paid].includes(pageConfig.type)) {
    useDefaultPaymentMethod = false;
  }
  return useDefaultPaymentMethod;
}

/**
 * INR F2P: don't use default payment method but select payment tile by default
 *
 */
export const changePaymentMethodOnPageLoad = (paymentMethodType) => {
  if (!isInrCurrency()) {
    return null;
  }
  if ([flowTypes.basic2pro, flowTypes.trial2paid].includes(pageConfig.type)) {
    switch (paymentMethodType) {
      case payMethodMap.credit:
      case payMethodMap.creditByIndia:
        return payMethodMap.credit;
      case payMethodMap.upi:
        return payMethodMap.upi;
      default:
        return null;
    }
  }
  return null;
};
